<div
  class="auction-images-popup bg-white position-fixed d-flex justify-content-around align-items-center"
>
  <div class="auction-images-popup__container">
    <div
      class="auction-images-popup__quantity px-0 mb-4 d-flex justify-content-between"
    >
      <div class="f-color-slate f-regular f-size-16">
        სურათები: {{ activeImage + 1 + "/" + images.length }}
      </div>
      <div
        (click)="closePopup()"
        class="auction-images-popup__container-close cursor-pointer"
      >
        <img src="/assets/images/close.svg" alt="X" />
      </div>
    </div>
    <div class="auction-images-popup__images position-relative">
      <div
        *ngIf="activeImage > 0"
        (click)="moveSlideLeft()"
        class="auction-images-popup__images-container-arrow auction-images-popup__images-container-arrow--left cursor-pointer d-inline-block position-absolute p-y-center"
      >
        <img src="/assets/images/arrow.svg" alt="left" />
      </div>
      <div
        *ngIf="activeImage < images.length - 1"
        (click)="moveSlideRight()"
        class="auction-images-popup__images-container-arrow auction-images-popup__images-container-arrow--right cursor-pointer d-inline-block position-absolute p-y-center"
      >
        <img src="/assets/images/arrow.svg" alt="right" />
      </div>
      <div
        class="auction-images-popup__images-container w-100 border-radius-m position-relative overflow-hidden d-flex justify-content-around align-items-center"
      >
        <picture
          *ngFor="let item of images; let k = index"
          [ngClass]="{ active: activeImage === k }"
          class="auction-images-popup__image align-items-center d-flex position-absolute"
        >
          <source
            *ngIf="!isOld"
            [srcset]="item.url + '.webp'"
            type="image/webp"
          />
          <source [srcset]="item.url + '.jpg'" type="image/jpeg" />
          <img
            [src]="item.url + '.jpg'"
            alt=""
            class="border-radius-l overflow-hidden m-auto"
          />
        </picture>
      </div>
    </div>
    <div
      class="auction-images-popup__gallery-wrapper w-100 overflow-hidden pb-3 d-none d-md-inline-block"
    >
      <div
        #gallery
        [ngStyle]="{ transform: 'translateX(' + galleryThumbsPosX + 'px)' }"
        class="auction-images-popup__gallery whitespace-nowrap"
      >
        <div
          *ngFor="let item of images; let k = index"
          [ngStyle]="{ 'background-image': 'url(' + item.url + '.jpg)' }"
          (click)="moveThumbs(k)"
          class="auction-images-popup__gallery-item position-relative d-inline-block bg-cover border-radius-m cursor-pointer"
        ></div>
        <div
          [ngStyle]="{ transform: 'translateX(' + thumbShapeX + 'px)' }"
          class="auction-images-popup__active-hover bg-black position-absolute"
        ></div>
      </div>
    </div>
  </div>
</div>
